<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #303133;
  /* width: 10rem; */
  margin: 0 auto;
  font-size: 14px;
  color: #919499;
  height: 100%;
}
html,body{height: 100%;}
.van-field__control--right{text-align: left !important;}
.van-search__content{border-radius: 20px;}
.van-fieldWrap{width: 100%;}
/* .van-field{padding: 0 !important;} */
/* .van-cell.switch-cell{padding: 8px 14px;} */
.van-fieldWrap>div{padding: 0 !important;}
.van-tag{padding: 6px 4px;}
</style>



// WEBPACK FOOTER //
// src/App.vue